import development from './development.json';
import production from './production.json';
import standard from './standard.json';
import test from './test.json';

const config = { development, production, test };

const stage = process.env.NODE_ENV;
// eslint-disable-next-line fp/no-let
let activeConfig = {};

const getConfig = () => {
  if (Object.keys(activeConfig).length === 0) {
    // eslint-disable-next-line fp/no-mutation
    activeConfig = { ...standard, ...config[stage?.toLowerCase()] };
  }
  return activeConfig;
};

export default getConfig;
